<template>
  <base-card :icons="[icon]" :heading="heading" :scrollable="true">
    <contact-automation-item
      v-for="(automation, index) in automations"
      :key="index"
      :automation="automation"
      :contact="contact"
    />
  </base-card>
</template>
<script>
import BaseCard from "../Components/UI/BaseCard.vue";
import ContactAutomationItem from "../Components/UI/ListItems/Automation/Contact.vue";

export default {
  data() {
    return {};
  },
  computed: {
    automations() {
      if (this.contact) {
        if (this.contact.automations) {
          return this.contact.automations;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
  },
  methods: {},
  created() {},
  components: {
    ContactAutomationItem,
    BaseCard,
  },
  props: ["heading", "icon", "contact"],
};
</script>
<style scoped></style>
